import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIClient } from "../../helpers/api_helper";
import { AUTH_LOGIN } from "../../helpers/url_helper";
import {authLoginThunks, authLogoutThunks, authProfileThunks} from "../thunks/authThunks";
import { getCookie, removeCookieWithLocalStorage , setCookieWithLocalStorage} from "../../helpers/browserStorageHelper";

// authSlice үүсгэх
const authSlice = createSlice({
  name: 'auth',
  initialState: {
    user: null as any | null, 
    token: null as any | null,
    loading: false as boolean,
    error: null as string | null,
  },
  reducers: {
    loadAuthData: (state)=>{
      // state.user.token = null;
      const {accessToken, refreshToken} = getCookie();

      if (accessToken) {
        if (!state.token) {
          state.token = {};
        }
        state.token.accessToken = accessToken; 
        // action.meta.arg.dispatch(fetchUserActivity(action.payload.id));
      }
      if (refreshToken) {
        if (!state.token) {
          state.token = {};
        }
        state.token.refreshToken = refreshToken; 
      }
    },
    logoutLocal: (state)=>{
      state.token=null;
      removeCookieWithLocalStorage();
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(authLoginThunks.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(authLoginThunks.fulfilled, (state, action) => {
        const {accessToken, refreshToken, user}=action.payload;
        const token={accessToken, refreshToken};
        state.loading = false;
        state.user= user;
        state.token= token;
      })
      .addCase(authLoginThunks.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Нэвтрэлт амжилтгүй боллоо';
      })
      .addCase(authLogoutThunks.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(authLogoutThunks.fulfilled, (state) => {
        state.loading = false;
        state.user= null;
        state.token= null;
        removeCookieWithLocalStorage();
      })
      .addCase(authLogoutThunks.rejected, (state) => {
        state.loading = false;
        state.user= null;
        state.token= null;
        state.error = null;
        removeCookieWithLocalStorage();
      })
      .addCase(authProfileThunks.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(authProfileThunks.fulfilled, (state, action) => {
        state.loading = false;
        state.user= action.payload?.data;
      })
      .addCase(authProfileThunks.rejected, (state) => {
        state.loading = false;
        state.user= null;
        state.error = null;
        removeCookieWithLocalStorage();
      });
  },
});

export const { loadAuthData, logoutLocal } = authSlice.actions;

export const authReducer= authSlice.reducer;
